module.exports = __webpack_public_path__ + "assets/img/产品价值.6ad177a3.png";